import UIList from 'UIComponents/list/UIList';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LabelAndSubInfo = ({
  label,
  subInfoBullets
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [label, /*#__PURE__*/_jsx(UIList, {
      children: subInfoBullets.map((bullet, index) => /*#__PURE__*/_jsx("span", {
        children: bullet
      }, index))
    })]
  });
};
export default LabelAndSubInfo;